import { render, staticRenderFns } from "./MainResidenceTypeCard.vue?vue&type=template&id=0f3dcb30&scoped=true&"
import script from "./MainResidenceTypeCard.vue?vue&type=script&lang=js&"
export * from "./MainResidenceTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./MainResidenceTypeCard.vue?vue&type=style&index=0&id=0f3dcb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3dcb30",
  null
  
)

export default component.exports